import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2">
      <path d="M8 21h8" />
      <path clipRule="evenodd" d="M1 15h8L5 4zm14 0h8L19 4z" strokeLinejoin="round" />
      <path d="M5 4h14m-7-2v20" />
    </g>
  </svg>
);
